import type { IdDocumentType } from '~domains/profile/entities/person';

export const idDocumentTypeNames: { [type in IdDocumentType]: string } = {
  UMID: 'UMID',
  SSS: 'SSS ID',
  MY_SSS: 'MySSS ID',
  PRC: 'PRC ID',
  PASSPORT: 'Philippine passport',
  DRIVING_LICENSE: "Driver's license",
  PHIL_ID: 'PhilSys ID',
  POSTAL_ID: 'Postal ID',
  PHIL_SYS_ID: 'PhilSys ID (Card type)',
  DIGITAL_NATIONAL_PHIL_ID: 'Digital national ID',
  E_PHIL_ID: 'ePhil ID (Paper type)',
};

export const idDocumentTypeOptions: Array<{
  value: IdDocumentType;
  label: string;
}> = [
  { value: 'UMID', label: idDocumentTypeNames.UMID },
  { value: 'SSS', label: idDocumentTypeNames.SSS },
  { value: 'MY_SSS', label: idDocumentTypeNames.MY_SSS },
  { value: 'PRC', label: idDocumentTypeNames.PRC },
  { value: 'PASSPORT', label: idDocumentTypeNames.PASSPORT },
  { value: 'DRIVING_LICENSE', label: idDocumentTypeNames.DRIVING_LICENSE },
  { value: 'PHIL_ID', label: idDocumentTypeNames.PHIL_ID },
  { value: 'POSTAL_ID', label: idDocumentTypeNames.POSTAL_ID },
  { value: 'PHIL_SYS_ID', label: idDocumentTypeNames.PHIL_SYS_ID },
  {
    value: 'DIGITAL_NATIONAL_PHIL_ID',
    label: idDocumentTypeNames.DIGITAL_NATIONAL_PHIL_ID,
  },
  { value: 'E_PHIL_ID', label: idDocumentTypeNames.E_PHIL_ID },
];
